export default "/images/7f8d25a98ba9b0350084ed1e8f832a44.avif";